import { useState, useEffect, useMemo } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { useEndSessionRequest, useDeleteSessionRequest, useGetInventoryItemsRequest } from '../../hooks/useApi';

export const useScanSessionReview = () => {
  const { inventoryId, sessionId } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();

  const sessionScans = state?.sessionScans || [];
  const areaName = state?.areaName || 'Area 1';
  const posId = state?.posId;

  const [showCancelModal, setShowCancelModal] = useState(false);
  const [showEndModal, setShowEndModal] = useState(false);
  const [inventoryItems, setInventoryItems] = useState([]);

  const [{ loading: deleteLoading }, deleteSession] = useDeleteSessionRequest(posId);
  const [{ loading: endLoading }, endSession] = useEndSessionRequest(posId);
  const [{ loading: itemsLoading }, getInventoryItems] = useGetInventoryItemsRequest(posId);

  useEffect(() => {
    if (!posId || !inventoryId) return;
    getInventoryItems({ bodyParams: { inventoryId: Number(inventoryId) } }).then((response) => {
      if (response?.data) setInventoryItems(response.data);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [posId, inventoryId]);

  const displayItems = useMemo(() => {
    const byBarcode = Object.fromEntries(inventoryItems.map(item => [item.barcode, item]));
    return sessionScans.map(scan => {
      const enriched = byBarcode[scan.barcode] || scan;
      return {
        ...enriched,
        quantity: scan.quantity ?? enriched.scannedQuantity,
        style: (enriched.modelCode && enriched.fabricCode)
          ? `${enriched.modelCode}${enriched.fabricCode}`
          : null,
      };
    });
  }, [sessionScans, inventoryItems]);

  const goBack = () => navigate(`/inventory-management/${inventoryId}`);

  const handleConfirmCancel = async () => {
    await deleteSession({ bodyParams: { inventoryId, sessionId } });
    goBack();
  };

  const handleConfirmEnd = async () => {
    await endSession({ bodyParams: { inventoryId, sessionId, sessionScans } });
    goBack();
  };

  return {
    areaName,
    displayItems,
    itemsLoading,
    deleteLoading,
    endLoading,
    showCancelModal,
    showEndModal,
    setShowCancelModal,
    setShowEndModal,
    handleConfirmCancel,
    handleConfirmEnd,
  };
};
